import {Button} from '@chekin/guestapp-ui-kit';
import {Copy} from 'lucide-react';
import {copyToClipboard} from 'utils/common';
import {useTranslation} from 'react-i18next';

type Props = {
  label: string;
  value: string;
};
export const Value = ({label, value}: Props) => {
  const {t} = useTranslation();
  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center justify-between gap-2">
        <div className="font-semibold">{label}</div>
        <Button
          variant="ghost"
          className="h-auto flex gap-2 text-[var(--primary)] hover:text-[var(--primary)] py-1"
          onClick={() => copyToClipboard(value)}
        >
          <Copy size={16} />
          {t('esim.my.copy')}
        </Button>
      </div>
      <div className="text-sm leading-6 bg-[var(--background-secondary)] rounded-lg p-2">
        {value}
      </div>
    </div>
  );
};
